<!-- 在线客服左侧列表 -->
<template>
  <div class="dialogbox">
  <Card :bordered="false" :padding="0">
     <div class="dialogtop">
        <div class="dialogtop-left">
            <p class="dialogtop-lefta" v-if = "onlineInfo ? onlineInfo.customerType : ''">{{onlineInfo ? onlineInfo.customerType : ''}}</p>
            <p class="dialogtop-leftb">{{customerName}}</p>
            <div class="left-button" v-if = "customerName">
              <img @click="linkCustomer" title="绑定客户" src="@/assets/image/online/linkicon.png"/>
            </div>

        </div>
        <div class="dialogtop-right">
            <div class="right-button">
              <img @click="transferSession" title="转接" src="@/assets/image/online/relay.png"/>
            </div>
            <div class="right-button">
              <img @click="inviteSession" title="邀请员工" src="@/assets/image/online/addseaticon.png"/>
            </div>
            <div class="right-button">
              <img @click="blockCustomer" title="加入黑名单" src="@/assets/image/online/addblackicon.png"/>
            </div>
            <div class="right-button">
              <img @click= "endSession" title="结束会话" src="@/assets/image/online/endicon.png"/>
            </div>
        </div>
     </div>
     <Tabs v-model="tabMid">
            <TabPane label="在线咨询" name="1">
              <div class="taleBox" :style="tableHeight">
                <!-- 显示更多历史记录 -->
                <div class="msgTipDiv" v-if="showMore && openId && onLineMsgList.length < totalSize">
                  <span class="moreDiv" @click="moreClick">查看更多消息</span>
                </div>
                <div class="cusandstaff" v-for= "(item, index) in onLineMsgList" :key="index">

                      <!-- tip有值显示tip -->
                      <div v-if="item.tip" class="msgTipDiv">
                        <span class="msgTip">{{timeFormat(item.createTime) + "  "+ item.tip}}</span>
                      </div>
                      <div v-else>
                      <!-- 当前座席与消息中的座席一致时，在右边，否则，都在左边 -->
                        <div v-if="item.agentNumber == currentAgentNumber" class="online_staff" >
                          <div  class="online_staff_infobk">
                                <img style="border-radius: 50%; " :src="item.headImg ? (item.headImg.indexOf('http') == 0 ? item.headImg : (baseImgURL + item.headImg)) : require('@/assets/image/customerService.png')" class="online_staff_infoimg" />
                          </div>
                          <div  class="online_staff_info" >
                            <div  class="online_staff_infodetail" >
                              <p  class="online_staff_info">{{timeFormat(item.createTime)+"&nbsp;&nbsp;&nbsp;&nbsp;"+ item.value}}</p>
                            </div>
                            <div class="online_staff_dialofont">
                            <!-- 暂时不知道什么原因，如果使用msg的时候，查看更多消息v-model的值不会刷新 -->
                               <!-- <Msg :msgType="item.msgType" v-model="item.content"/> -->
                                <div v-if="item.msgType == 'text'" ref="msgDiv" v-html="replaceMsg(item.msgType,item.content)" class="msgP"></div>
                                <p v-if="item.msgType == 'link'" class="msgP"><a style="color:#1890ff;text-decoration: underline;" :href="item.content" target="_blank">{{item.content}}</a></p>
                                <el-image v-if="item.msgType == 'image'" style="width: 100px; height: 100px" :src="baseImgURL + item.content"
                                                        :preview-src-list="(baseImgURL + item.content).split('{yuneasy}')" fit="contain"></el-image>
                                <audio v-if="item.msgType == 'voice'" :src="baseImgURL + item.content" controls style="height: 30px;"> </audio>
                                <video v-if="item.msgType == 'video'" width="200" height="115" controls controlsList="nodownload" disablePictureInPicture :src="baseImgURL + item.content"/>
                            </div>
                          </div>
                        </div>
                        <div v-else class="online_cus">
                          <div class="online_cus_infoimg">
                            <img style="border-radius: 50%; " :src="item.headImg ? (item.headImg.indexOf('http') == 0 ? item.headImg : (baseImgURL + item.headImg)) : require('@/assets/image/customerService.png')"/>
                          </div>
                          <div  class="online_cus_info">
                            <div  class="online_cus_infodetail">
                              <p  class="online_cus_info">{{item.value + "&nbsp;&nbsp;&nbsp;&nbsp;"+ timeFormat(item.createTime)}}</p>
                            </div>
                            <div class="online_cus_dialofont">
                              <!-- <Msg :msgType="item.msgType" v-model="item.content"/> -->
                                <div v-if="item.msgType == 'text'" ref="msgDiv"  v-html="replaceMsg(item.msgType,item.content)" class="msgP"></div>
                                <p v-if="item.msgType == 'link'" class="msgP"><a style="color:#1890ff;text-decoration: underline;" :href="item.content" target="_blank">{{item.content}}</a></p>
                                <el-image v-if="item.msgType == 'image'" style="width: 100px; height: 100px" :src="baseImgURL + item.content"
                                                        :preview-src-list="(baseImgURL + item.content).split('{yuneasy}')" fit="contain"></el-image>
                                <audio v-if="item.msgType == 'voice'" :src="baseImgURL + item.content" controls style="height: 30px;"> </audio>
                                <video v-if="item.msgType == 'video'" width="200" height="115" controls controlsList="nodownload" disablePictureInPicture :src="baseImgURL + item.content"/>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
              </div>
              <div class="dialog-inputbox">
                  <div class="inputbox-iconlist">
                      <div class="inputbox-button" v-if="false">
                        <img src="@/assets/image/online/Ticon.png"/>
                      </div>
                       <Poptip :disabled = "openId ? false : true" placement="top" transfer class="inputbox-button">
                            <img src="@/assets/image/online/Emoticon.png"/>
                            <div slot="content" >
                                <div v-for="(item, index) in emojiList" :key="index">
                                  <img :src="emotion.emoji" v-for="(emotion,key) in item" :key="key" :title="emotion.descr" @click="clickHandler(emotion)"/>
                                </div>
                            </div>
                        </Poptip>

                      <div class="inputbox-button">
                      <!-- 文件 -->
                        <Upload :action="baseUploadUrl" :disabled = "openId ? false : true" :show-upload-list="false" accept=".mp4" :on-success="(res,file)=>onSuccess(res)" :before-upload="beforeUpload" :on-error="uploadFail">
                          <img src="@/assets/image/online/foldericon.png"/>
                        </Upload>

                      </div>
                      <div class="inputbox-button">
                      <!-- 图片 -->
                      <Upload :action="baseUploadUrl" :disabled = "openId ? false : true" :show-upload-list="false" accept="image/gif, image/jpeg, image/jpg, image/png" :format="['jpg','jpeg','png','gif']" :on-format-error="handleFormatError" :on-success="(res,file)=>onSuccess(res)" :before-upload="beforeUpload" :on-error="uploadFail">
                        <img src="@/assets/image/online/picicon.png"/>
                      </Upload>
                      </div>
                      <div class="inputbox-button" v-if="false">
                        <img src="@/assets/image/online/score.png"/>
                      </div>
                  </div>

                  <div class="edittext" @paste="onPaste" :contenteditable="openId ? true : false" ref="editDiv" placeholder="Enter发送，Shift+Enter换行" @keydown="keypressEvent">
                  </div>
              </div>

            </TabPane>
            <TabPane label="服务记录" name="2" v-if="false">
                        <div class="fixed_table">
                          <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" :class="{'tableClass':tableClass}" stripe  ref="selection"  @selection-change="getSelectedId">
                            <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
                            <el-table-column  fixed="right" label="操作" v-if="contentList.length>0"  align="center">
                              <template slot-scope="scope">
                                <el-button  type="text" size="small" @click="linkCustomer(scope.row.id)">详情</el-button>
                              </template>
                            </el-table-column>
                          </el-table>
                          <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
                        </div>
            </TabPane>
     </Tabs>
     </Card>
     <SearchCustomerInfoPop  @closeCustomerInfo="closeCustomerInfo" :showCustomerInfo="showCustomerInfo"></SearchCustomerInfoPop>
     <TransferSession  @closeTransferPage="closeTransferPage" :showTransfer="showTransfer" :transferType = "transferType" :msgSource="msgSource"></TransferSession>
     <BlackSession  @closeTransferPage="closeTransferPage" :showBlack="showBlack" ></BlackSession>
  </div>
</template>

<script>
import {publicFunClass} from '@/components/js/PublicFunClass.js';
import Msg from '@/components/OnlineService/Msg.vue';
import TransferSession from '@/components/OnlineService/TransferSession.vue';
import BlackSession from '@/components/OnlineService/BlackSession.vue';
import SearchCustomerInfoPop from '@/components/customerMange/SearchCustomerInfoPop.vue';
import eventBus from "../../util/eventBus";
  export default {
    name: "OnlineMidcon",
    mixins:[publicFunClass],
    props:{
      openId: String,
      ShowService: Boolean,
    },
    components:{
      Msg,
      SearchCustomerInfoPop,
      TransferSession,
      BlackSession,
    },
    data() {
      return {
        tabMid:'1',
        showMore: false,
        tableHeight:{height:''},
        totalSize: 0,
        spinShow: false,
        showCustomerInfo:false,
        tableClass: true,
        contentList: [{"a":"测试","b":"157123090877","c":"合肥","d":"测试","e":"无","f":"2021-08-03"},{"a":"研发","b":"15809034589","c":"上海","d":"测试","e":"无","f":"2021-05-03"}],
         fieldList: [
          {type: 'selection', width: 50, fixed: true},{key:'a','title':'客户名称', fixed: true},{key:'b','title':'手机号码', fixed: true},
          {key:'c','title':'手机归属地', fixed: true},{key:'d','title':'员工姓名'}, {key:'e','title':'服务备注'},
          {key:'f','title':'下次联系时间'}
        ],
        baseUploadUrl: this.baseURL+"common/upload.json?type=wx&companyNo="+localStorage.getItem("companyId"),
        onLineMsgList:[], //消息列表
        agentInfo: JSON.parse(localStorage.getItem("agentInfo")), //座席信息
        currentAgentNumber: '',  //当前登录座席工号
        inputContent: '', //输入的内容
        wxName: '', //微信号
        sessionId: '',
        sessionChannel:'', //渠道类型
        currentPage:1,
        pageSize:20,
        customerName: '', //客户名称
        emojiList: require('@/assets/emotion.json'),

        msgType: 'text',
        msgSource: '',
        showTransfer: false, //显示转接页面
        transferType: '1',
        showBlack: false,
        headImg: '',
        sessionType: '0', //会话类型 ，0默认排队1已分配2转接会话3多方会话,
        onlineInfo: null,
        isScroll: true, //是否把消息框滑动到最下面
        configInfo: JSON.parse(localStorage.getItem("configInfo")),
      }
    },
    created() {
      let clientHeight=document.documentElement.clientHeight;
      this.tableHeight.height=this.mountHeight(328);
    },
    mounted() {
      this.currentAgentNumber = this.agentInfo.agentNumber;
      let that = this;
      eventBus.$on('beforeSend', function (msg) {
        that.$refs.editDiv.innerHTML = msg;
      });
      eventBus.$on('clickSend', function (msg) {
        that.msgType = "text";
        that.sendMsg(msg);
        that.$refs.editDiv.innerHTML = "";
        that.inputContent = "";
      });
    },
    destroyed() {
      this.sessionId = "";

      eventBus.$off('beforeSend');
      eventBus.$off('clickSend');
    },
    methods: {
      // 选中客户后的事件处理
     closeCustomerInfo:function(flag,selection){
       this.showCustomerInfo=false;
       if(flag){
          this.onlineInfo = this.$store.getters.getOnlineInfoByOpenId(this.openId);
          if(this.onlineInfo){
            let phoneIsHide= this.configInfo.phoneIsHide;
            let showColumnList = this.onlineInfo.rightInfo;
            for (let i=0; i<showColumnList.columnList.length; i++){
              let customColName= showColumnList.columnList[i].customColName;
              let type= showColumnList.columnList[i].type;
              if(type=='checkbox' || type=='radio' || type=='select' || type =='cascade'){
                showColumnList.columnList[i].customValue = selection[customColName+'Id'];
              }else{
                if(customColName.indexOf('telephone') != -1){
                  showColumnList.columnList[i].customValue = selection[customColName]; //原始的字段信息，比如手机号码，会存放不加密的号码
                  if(phoneIsHide=='1'){
                    showColumnList.columnList[i].customValue = selection[customColName+"Hide"];
                    showColumnList.columnList[i].customOrigin  = selection[customColName];
                  }
                }else{
                  showColumnList.columnList[i].customValue = selection[customColName];
                }
              }
            }
            showColumnList['openId'] = this.openId;
            showColumnList['lastCustomerId'] = showColumnList.customerId;
            showColumnList['customerId'] = selection.id;
            this.$store.commit('pushOnlineRightInfo',showColumnList);
            eventBus.$emit('updateCustom', showColumnList);
          }
       }
      },
      closeTransferPage: function(type,agentNumber,blackReason){

        this.showTransfer = false;
        this.showBlack = false;
        if(type &&　type != "cancel"){
          let confirmContent = "";
          if(type == "1"){
            confirmContent = "是否转接员工"+agentNumber;
          }else if(type == "2"){
            confirmContent = "是否邀请员工"+agentNumber;
          }else if(type == "3"){
            confirmContent = "是否加入黑名单";
          }
          let that = this;
          this.$Modal.confirm({
            title: '提示',
            content: confirmContent,
            onOk: () => {
              that.request(type,agentNumber,blackReason);
            }
          });
        }
      },
      // 关联客户
      linkCustomer: function(){
        if(this.openId){
          this.showCustomerInfo=true;
        }else{
          this.$Message.error("请先选择咨询客户");
        }
      },
      // 转接会话
      transferSession: function(){
        if(!this.sessionId){
          this.$Message.error("请先选择咨询客户");
          return false;
        }
        let onlineInfo = this.$store.getters.getOnlineInfoByOpenId(this.openId);
        let state = 0;
        if(onlineInfo && onlineInfo.msgList){
          for (let i=onlineInfo.msgList.length-1;i >= 0;i--){
            if(onlineInfo.msgList[i].sessionStatus){
              if('2' == onlineInfo.msgList[i].sessionStatus){
                state = onlineInfo.msgList[i].sessionStatus
              }
              break;
            }
          }
          if('2' == state){
            this.$Message.error("当前会话已结束");
            return false;
          }
        }
        this.msgSource = onlineInfo.msgSource ? onlineInfo.msgSource : this.currentAgentNumber;
        this.transferType = '1';
        this.showTransfer = true;

        // let that = this;
        // this.$Modal.confirm({
        //     title: '提示',
        //     content: "是否转接会话",
        //     onOk: () => {

        //     }
        //   });
      },
      // 邀请会话
      inviteSession: function(){
        if(!this.sessionId){
          this.$Message.error("请先选择咨询客户");
          return false;
        }
        let onlineInfo = this.$store.getters.getOnlineInfoByOpenId(this.openId);
        let state = 0;
        if(onlineInfo && onlineInfo.msgList){
          for (let i=onlineInfo.msgList.length-1;i >= 0;i--){
            if(onlineInfo.msgList[i].sessionStatus){
              if('2' == onlineInfo.msgList[i].sessionStatus){
                state = onlineInfo.msgList[i].sessionStatus
              }
              break;
            }
          }
          if('2' == state){
            this.$Message.error("当前会话已结束");
            return false;
          }
        }
        this.msgSource = onlineInfo.msgSource ? onlineInfo.msgSource : this.currentAgentNumber;
        this.transferType = '2';
        this.showTransfer = true;
      },
      // 屏蔽客户
      blockCustomer: function(){
        if(!this.sessionId){
          this.$Message.error("请先选择咨询客户");
          return false;
        }
        this.showBlack = true;
      },
      // 结束会话
      endSession: function(){
        if(!this.sessionId){
          this.$Message.error("请先选择咨询客户");
          return false;
        }
        let that = this;
        this.$Modal.confirm({
            title: '提示',
            content: "是否结束会话",
            onOk: () => {
              that.request("4","","");
            }
          });
      },
      // http接口请求 type 1转接2 邀请3 拉黑 4结束
      request: function(type,agentNo, blackReason){
        let param = {
          "type": type,
          "sessionId": this.sessionId,
          "agentNo": agentNo,
          "blackReason": blackReason,
          "journalType": type == "1" ? "待处理转接会话" : (type == "2" ? "待处理邀请会话" : (type == "3" ? "加入黑名单" : (type == "4" ? "结束会话" : ""))),
          "menuId":"null",
        }
        let that = this;
        this.$http.post("chatInterface/doChatStatus.json",param).then(function (res) {  //待处理客户查询
              let result=res.data.flag;
              if(result!="666"){
                that.$Message.info(res.data.msg);
                return false;
              }
              if(type == "1"){ //转接成功
                that.$store.commit('delOnlineData',that.openId);
                that.$Message.success("转接成功");
                // 转接成功后，回调左边的方法
                that.$emit("callbackFun", that.openId);
              }else if(type == "2"){ //邀请成功，
                // that.$store.getters.getOnlineInfoByOpenId(that.openId).leftInfo.sessionType = "3";
                that.$Message.success("邀请成功");
                that.initValue();
              }else if(type == "3"){
                that.$Message.success("加入黑名单成功");
              }else if(type == "4"){
                that.$Message.success("结束成功");
                that.$emit("callbackFun", that.openId);
                that.$store.commit('delOnlineData',that.openId);
                window.midChangeCallbackFun(""); //删除时改变中间和右侧数据
              }
            })
      },
      // 滑动到底部
      scrollToBottom: function () {
          this.$nextTick(() => {
              var container = this.$el.querySelector(".taleBox");
              container.scrollTop = container.scrollHeight;
          });
      },
      // 固定
      scrollFix: function () {
          this.$nextTick(() => {
              var container = this.$el.querySelector(".taleBox");
              container.scrollTop = container.scrollHeight / this.currentPage;
          });
      },
      // 回车发送消息
      keypressEvent: function(event){
        if (!event.shiftKey && event.keyCode == 13){
          let onlineInfo = this.$store.getters.getOnlineInfoByOpenId(this.openId);
          let state = 0;
          if(onlineInfo && onlineInfo.msgList){
            for (let i=onlineInfo.msgList.length-1;i >= 0;i--){
              if(onlineInfo.msgList[i].sessionStatus){
                if('2' == onlineInfo.msgList[i].sessionStatus){
                  state = onlineInfo.msgList[i].sessionStatus
                }
                break;
              }
            }
            if('2' == state){
              this.$Message.error("当前会话已结束");
              return false;
            }
          }
          let newHtml = this.$refs.editDiv.innerHTML;
          let str = newHtml.replace(/<br\/>/g, "\n").replace(/<br>/g, "\n")  //替换回车换行
                              .replace(/<\/?.+?\/?>/g,''); //替换html标签
          let newStr = str.replace(/[ ]|[\r\n&nbsp;]/g,"");
          if(!newStr){
            this.$Message.error("请输入发送内容");
            this.$refs.editDiv.innerHTML = "";
            this.inputContent = "";
            return false;
          }
          this.inputContent = str;
            event.preventDefault() // 阻止浏览器默认换行操作
          // {"sessionChannel":-8,"msgType":"text","openId":"o8NZexHwB5eUGfcbPQVzzWwxX_sw","messageId":54,"sessionId":"12","type":"pushPointChatMessage",
          // "content":"嘻嘻嘻","createTime":"2021-01-14 14:40:10","name":"。","tip":"","wxName":"gh_c4925330ce91","msgSource":"1"}
          this.msgType = "text";
          this.sendMsg(this.inputContent);
          this.$refs.editDiv.innerHTML = "";
          this.inputContent = "";
        }
      },
      // 发送消息
      sendMsg(content){
        content = content.replace(/<br\/>/g, "\n").replace(/<br>/g, "\n").replace(/&nbsp;/g,' ')  //替换回车换行
        .replace(/<\/?.+?\/?>/g,''); //替换html标签
        if(!content){
          this.$Message.error("请输入发送内容");
          return false;
        }
        let msg = {
            "msgType": this.msgType,
            "content": content,
            "openId": this.openId,
            "value": this.currentAgentNumber,
            "tip":"",
            "agentNumber": this.currentAgentNumber,
            "sessionId":  this.sessionId,
            "wxName": this.wxName,
            "sessionChannel": this.sessionChannel,
            "msgSource": this.msgSource,
            "createTime": this.getCurrentTime(),
            "type":"pushPointChatMessage",
            "msgMark": this.getTime(),
            "headImg": this.agentInfo.employeeHead ? this.agentInfo.employeeHead : "",
            "sessionType": this.sessionType,
          }
          this.$emit('sendMessage',msg);
          this.isScroll = true;
          return false
      },
      // 表情点击
      clickHandler: function(item){
        this.inputContent = this.$refs.editDiv.innerHTML + "<font style='display:none'>"+item.chars+"</font><img src='"+item.emoji+"'/>";

        this.$refs.editDiv.innerHTML = this.inputContent;
      },
      // 查询sessionId的历史数据
      initHistoryMsg: function(number){
       let thisTime = this.onLineMsgList.length == 0 ? this.getCurrentTime() : this.onLineMsgList[0].createTime;

        let param = {
            journalType:"null",
            menuId:"null",
            openId: this.openId,  //1待处理 2排队中
            pageNum:1,
            pageSize:this.pageSize,
            createTime: thisTime,
          }
          let that = this;
          this.$http.post("chatInterface/toChatDetail.json",param).then(function (res) {  //消息查询
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            // that.onLineMsgList.unshift(res.data.obj.list.content.reverse()); //倒序排列
            that.totalSize = res.data.obj.list.totalSize;
            that.$store.commit('pushMsgList',res.data.obj.list.content);
            that.showMore = true;
            // that.initValue();
            // that.scrollToBottom();
          })
      },

      getCurrentTime: function(){
        let time = new Date();
        return this.formatDate(time,"yyyy-MM-dd hh:mm:ss");
      },
      getTime: function(){
        let time = new Date();
        return time.getTime();
      },
      initValue: function(){
        this.showMore = false;
        if(this.openId){
          this.currentPage = 1;
          this.onlineInfo = this.$store.getters.getOnlineInfoByOpenId(this.openId);
          if(this.onlineInfo){
            this.onLineMsgList = this.onlineInfo.msgList;
            // if(this.onLineMsgList.length <= 0){
            //   // 查询历史记录
            //   this.initHistoryMsg();
            // }else{
            //   this.onLineMsgList = this.onlineInfo.msgList;
            // }
            this.initHistoryMsg("1");
            let newSource = this.onlineInfo.leftInfo.msgSource ? this.onlineInfo.leftInfo.msgSource : this.currentAgentNumber;
              this.wxName = this.onlineInfo.wxName;
              this.sessionChannel = this.onlineInfo.sessionChannel;
              this.openId = this.onlineInfo.openId;
              this.sessionId = this.onlineInfo.sessionId;
              this.customerName = this.onlineInfo.name;
              this.msgSource = JSON.parse(JSON.stringify(newSource));
              this.headImg = this.onlineInfo.leftInfo.headImg;
              this.sessionType = this.onlineInfo.leftInfo.sessionType;
          }
        }else{
          this.onLineMsgList = [];
          this.wxName = "";
          this.sessionChannel = "";
          this.openId = "";
          this.sessionId = "";
          this.customerName = "";
          this.msgSource = "";
          this.headImg = "";
          this.sessionType = "";
        }
      },
      //上传成功
        onSuccess(res) {
          if(res.flag != '666'){
            this.$Message.error(res.msg);
            return false;
          }
          this.sendMsg(res.obj.absolutePath);
        },
        //上传失败
        uploadFail(){
          this.$Message.error("上传失败");
        },
        beforeUpload (file) {
          if("image/jpeg"== file.type || "image/png"== file.type || "image/jpg"== file.type || "image/gif"== file.type){
            if(file.size > 10240*1000){
              this.$Message.error("图片"+file.name + "超出文件大小限制，上传文件不能超过10M。");
              return false;
            }
            this.msgType = "image";
          }else if("audio/mpeg" == file.type){
            if(file.size > 2048*1000){
              this.$Message.error("语音"+file.name + "超出文件大小限制，上传文件不能超过2M。");
              return false;
            }
            this.msgType = "voice";
          }else if("video/mp4" == file.type){
            if(file.size > 10240*1000){
              this.$Message.error("视频"+file.name + "超出文件大小限制，上传文件不能超过10M。");
              return false;
            }
            this.msgType = "video";
          }
        },
        handleFormatError(file){
          this.$Message.error(file.name + "文件格式错误，请上传JPEG/PNG/JPG/GIF格式图片。");
        },
        moreClick: function(){
          // 查询更多历史记录
          this.currentPage++;
          this.isScroll = false;
          this.initHistoryMsg();
        },
        // ctrl v粘贴事件
        onPaste: function(e){
          // Stop data actually being pasted into div
          e.stopPropagation();
          e.preventDefault();
        },
        readMsg: function(sessionId){
          let param = {
          "sessionId": sessionId,
          }
          let that = this;
          this.$http.post("chatInterface/doIsRead.json",param).then(function (res) {  //待处理客户查询
                let result=res.data.flag;
                if(result!="666"){
                  that.$Modal.info({
                    title:'提示',
                    content:res.data.msg
                  });
                  return false;
                }
          });
        },
        replaceMsg: function(msgType, msgContent){
        if(msgType == "text"){
            if(msgContent.indexOf('/:') > -1){
                for(let i = 0; i < this.emojiList.length; i++){
                    for(let n = 0; n < this.emojiList[i].length; n++){
                        let newChar = this.htmlToString(this.emojiList[i][n].chars);
                        msgContent = msgContent.replace(new RegExp(RegExp.escape(newChar),'g'),"<img src='"+ this.emojiList[i][n].emoji+"'/>");
                    }
                }
            }
            return msgContent;
        }
          RegExp.escape= function(s) {
            return s.replace(/[-\/:\\^$*+?.()|[\]{}><@&]/g, '\\$&');
          };
        },
        htmlToString:function (sHtml) {
          return sHtml.replace(/[<>&"]/g,function(c){return {'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;'}[c];});
        },

    },
    watch: {

      // 监听左侧点击客户列表时openId的变化，变化了要重新获取聊天记录
      // 聊天记录如果是座席发，name值是座席名称，如果不是座席发，显示客户名称（群聊情况下，本座席发在右边，访客和其他座席发在左边）
      openId(){
        this.showMore = false;
        this.initValue();
      },
      // 监听中间显示对话数据，滑动到最下面
      onLineMsgList(){

        if(!this.isScroll){
          this.scrollFix();
        }else{
          this.scrollToBottom();
        }
        
        if(this.onlineInfo && this.onlineInfo.leftInfo){
          this.sessionId = this.onlineInfo.leftInfo.sessionId;
        
          // 收到消息，将当前会话session标为已读,只有在在线客服页面时这样
          if(this.ShowService && this.sessionId){
            this.readMsg(this.sessionId);
            this.$store.commit('delUnreadCnt', Number(this.onlineInfo.leftInfo.unreadCnt));
            this.onlineInfo.leftInfo.unreadCnt = "0";
            this.$store.commit('removeGlobalNoticeMsgList', this.onlineInfo.leftInfo.openId);
          }
        }
        // }
      },
      ShowService(){
        if(this.ShowService && this.sessionId){
          this.readMsg(this.sessionId);
          this.$store.commit('delUnreadCnt', Number(this.onlineInfo.leftInfo.unreadCnt));
          this.onlineInfo.leftInfo.unreadCnt = "0";
          this.scrollToBottom();
        }
      }
    }

  }
</script>
<style scoped lang="less">
.edittext:empty::before{
			color:lightgrey;
			content:attr(placeholder);
		}

.msgTipDiv{
  text-align: center;
  color: #666;
  margin: 10px;
}
.msgTip{
      max-width: 320px;
    overflow: hidden;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px;
    padding: 0 16px;
    line-height: 24px;
    color: #919ea7;
    margin-top: 10px;
    height: 24px;
    background: #f1f5f9;
    border-radius: 2px;
}
.moreDiv{
  cursor: pointer;
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/components/OnlineService/OnlineMidcon.vue